/** One SSR-hydrated flag shared by every part of PLP navigation. */
export function useKeepFilters() {
    return useState<boolean>('plp-keep-filters-enabled', () => false);
}
